/**
 * Bridge Club Animals Page
 *
 * Uses the shared AnimalManager component with Bridge Club API endpoints.
 * Provides the same smart animal setup experience as Store Club Farm.
 */

import React from 'react';
import BridgeClubLayout from '../../components/BridgeClub/BridgeClubLayout';
import AnimalManager from '../../components/shared/AnimalManager';

const BridgeClubAnimals: React.FC = () => {
  return (
    <BridgeClubLayout>
      <AnimalManager
        apiBase="/bridge-club"
        themeColor="#B91C1C"
        selectedButtonColor="#60A5FA"
        onError={(error) => console.error('[BridgeClubAnimals] Error:', error)}
      />
    </BridgeClubLayout>
  );
};

export default BridgeClubAnimals;
